"use client";
import { HTMLAttributes, useEffect, useState } from "react";
import Image from "next/image";
import btn_back from "@/app/assets/orders/btn_back@2x.png";
import { useRouter } from "next/navigation";

export type EventCardProps = {
  data?: HeaderBackType
};

export type HeaderBackType = {
  title?: string,
}
export const HeaderBack: React.FC<
  HTMLAttributes<HTMLDivElement> & EventCardProps
> = ({ children, data, ...props }) => {
  const router = useRouter();
  const [title, setTitle] = useState(data?.title);

  const goBack = () => {
    console.log("goBack");
    router.back();
  };
  useEffect(() => {
    const title = data?.title === 'localStorage' ? globalThis.localStorage.getItem("chat_title") || "Paul" : data?.title
    setTitle(title)
  }, [data?.title])

  return (
    <div className={props.className ? props.className + " flex items-center pb-18 pl-15 pr-10" : "flex items-center pb-18 pl-15 pr-10"}>
      <div className="cursor-pointer relative z-20" onClick={goBack}>
        <Image src={btn_back} alt="btn_back" width={28} height={28} />
      </div>
      {
        title ? (
          <h2 className="flex-1 flex justify-center items-center" style={{ marginLeft: '-3.3rem' }}>
            <span className="text-17 text-bravve-200 font-bold" style={{maxWidth: '80%'}}>{title === 'localStorage' ? "Paul" : title}</span>
          </h2>
        )
          : children
      }
    </div>
  )
}